module.exports = __webpack_public_path__ + "static/spot-workers-quote-4ac6797662966b3a38473198ef401a1e.png";